import React from 'react';
import cx from 'classnames';
import cs from '../index.module.scss';

const TrendsIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 34C26.8366 34 34 26.8366 34 18C34 9.16344 26.8366 2 18 2C9.16344 2 2 9.16344 2 18C2 26.8366 9.16344 34 18 34ZM18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z"
        fill="#ED0070"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6229 18.5804L18.5901 10.0645C18.4918 10.0645 18.3934 10.0484 18.2951 10.0323C18.1967 10.0161 18.0983 10 18 10C17.3442 10 16.6229 10.0645 15.9672 10.2581L15.0492 14.2579H10.8525C10.459 15.0321 10.1311 15.8708 10 16.774H14.459L14.0656 18.5804H16.6229ZM17.7373 16.7743H25.9996C25.8684 15.8711 25.6061 15.0325 25.2127 14.2583H22.7865L23.3111 11.9358C22.5897 11.3551 21.8684 10.9035 21.016 10.581L20.1635 14.2583H18.3275L17.7373 16.7743ZM18.2623 19.2262L17.6721 21.7422H15.836L14.9836 25.4195C14.1311 25.0969 13.4098 24.6453 12.6885 24.0647L13.2131 21.7422H10.8525C10.459 20.968 10.1311 20.1294 10 19.2262H18.2623ZM25.9904 19.2905C25.9938 19.2691 25.997 19.2476 26.0001 19.226V19.2905H25.9904ZM25.1477 21.7421C25.5317 20.9864 25.8533 20.1692 25.9904 19.2905H21.6067L22.0002 17.4841H19.4428L17.4756 26H18.0657C18.7215 26 19.4428 25.9355 20.0985 25.742L20.951 21.7421H25.1477Z"
        fill="#ED0070"
      />
    </svg>
  </span>
);

export default TrendsIcon;
